import React from 'react';
import cn from 'classnames';

import close from 'assets/images/close-btn-black.svg';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import call from 'utils/functions/call.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import asInput from 'utils/strings/asInput.util';

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.service.description,
      rows: 1,
      minRows: 1,
      maxRows: 20, // max height textarea ~ 400px
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { service: prevService } = this.props;
    const { service: nextService } = nextProps;

    if (nextService && nextService.description !== prevService.description) {
      this.setState({ value: nextService.description });
    }
  }

  onChangeDescription = (event) => {
    const textareaLineHeight = 14;
    const { minRows, maxRows } = this.state;

    const previousRows = event.target.rows;
    event.target.rows = minRows; // reset number of rows in textarea

    const currentRows = event.target.scrollHeight / textareaLineHeight;

    if (currentRows === previousRows) {
      event.target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }

    this.setState({
      value: event.target.value,
      rows: currentRows < maxRows ? currentRows : maxRows,
    });
  };

  saveDescription = () => {
    const { service } = this.props;
    service.description = this.state.value;

    call('Item.saveService', this.props.saveService, service);
  };

  onBlur = () => {
    this.saveDescription();

    call('Item.onOpenDropdown', this.props.onOpenDropdown);
  };

  render() {
    const { rows, value } = this.state;
    const { service } = this.props;

    const isLonger = value?.length > 1;

    return (
      <label data-bem="Item" className="s-item-content cfix">
        <span data-bem="Item__name" className="s-item-name">
          {service.name}
        </span>
        <div data-bem="Item__value" className="relative">
          <textarea
            data-bem="Item__input"
            className={cn({
              's-textarea': true,
              1: isLonger,
              2: !isLonger,
            })}
            rows={rows}
            placeholder="Enter description here"
            value={asInput(value)}
            onChange={this.onChangeDescription}
            onFocus={this.onChangeDescription}
            onBlur={this.onBlur}
          />
        </div>
      </label>
    );
  }
}

const ServiceItems = ({ onOpenDropdown, saveService, services }) => (
  <>
    {asArray(services).map((service, index) => (
      <Item key={createNodeKey({ index, tag: service?.name })} service={service} saveService={saveService} onOpenDropdown={onOpenDropdown} />
    ))}
  </>
);

class ServiceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { services: props.services };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.services) {
      this.setState({ services: nextProps.services });
    }
  }

  render() {
    const { onOpenDropdown, saveService } = this.props;
    const { services } = this.state;

    return (
      <div data-bem="ServiceItems" className="s-list">
        <div data-bem="ServiceItems__item" className="s-item">
          <ServiceItems services={services} saveService={saveService} onOpenDropdown={onOpenDropdown} />
        </div>
      </div>
    );
  }
}

class ServiceDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: false,
      services: props.services,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.services) this.setState({ services: nextProps.services });
  }

  onOpenDropdown = () => void this.setState({ isHidden: !this.state.isHidden });
  onSave = () => {};

  render() {
    const { saveService, generalName, t } = this.props;
    const { isHidden, services } = this.state;

    return (
      <div
        data-bem="ServiceDropdown"
        className={cn({
          's-wrap': true,
          open: isHidden,
          close: !isHidden,
        })}
      >
        <span className="s-cat-name" onClick={this.onOpenDropdown} role="button" tabIndex={0}>
          {generalName}
          {S.space}
        </span>

        {isHidden && (
          <span className="s-done-btn" onClick={this.onOpenDropdown} role="button" tabIndex={0}>
            {t('common.buttons.doneUpp')}
          </span>
        )}

        {isHidden && <ServiceList categoryName={generalName} services={services} saveService={saveService} onOpenDropdown={alwaysNoop} />}
      </div>
    );
  }
}

const AddEditServiceDescriptionModal = ({ categoryServices, saveService, proceedToSave }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="AddEditServiceDescriptionModal" id="modal-add-edit-services">
      <div className="disable-click-overlay when-service-modal" />

      <div className="big-modal" style={{ display: 'flex' }}>
        <div className="big-modal-body cfix">
          <div className="text-header">{t('onlineBooking.generalSettings.serviceDescription.addEditServiceModal.description')}</div>

          {asArray(categoryServices).map((category, index) => (
            <ServiceDropdown
              key={createNodeKey({ index, tag: category.name })}
              generalName={category.name}
              services={category.services}
              saveService={saveService}
              proceedToSave={proceedToSave}
              t={t}
            />
          ))}
        </div>
        <img className="big-modal-close" src={close} alt="close" onClick={proceedToSave} />
      </div>
    </div>
  );
};

export default AddEditServiceDescriptionModal;
